import React from "react";
import { useSelector } from "react-redux";
import { Divider, View } from "@adobe/react-spectrum";
import "./style.css";
import CaseDetails from "./CaseDetails";
import CaseInfoDetail from "./CaseInfoDetail";
import { RootState } from "../../../store";
import CaseInformationHeader from "./CaseInformationHeader";
import { IndividualTask } from "../../../amazon-connect/models/task";

interface CaseInformationContainerProps {}

const CaseInformationContainer: React.FC<CaseInformationContainerProps> = () => {
  let cases = useSelector((state: RootState) => state.cases);
  const activeCase = cases.cases.find(
    (indCase: IndividualTask) => indCase.id === cases.activeCaseID
  );

  return (
    <View UNSAFE_className="caseinformationcontainer-wrapper">
      <CaseInformationHeader activeCase={activeCase} />
      <Divider size="M" />
      <View UNSAFE_className="case-details-scroll-container">
        <CaseDetails activeCase={activeCase} />
      </View>
      <View UNSAFE_className="container-information" marginTop={"5px"} marginBottom={"16px"}>
        <CaseInfoDetail activeCase={activeCase} />
      </View>
    </View>
  );
};

export default CaseInformationContainer;